// User-Data-Isolation via Namespace-per-User
//
// Neuer Ansatz: Statt beim User-Wechsel Daten zu löschen, hängt `userStorage`
// den User-Suffix `::uid::<id>` an alle user-spezifischen localStorage-Keys.
// Jeder User hat seinen eigenen Namespace, die Daten bleiben erhalten wenn
// man sich ausloggt und später wieder einloggt.
//
// Die alte `clearUserLocalData`-Logik wird bewusst NICHT mehr aufgerufen,
// weil sie echten Datenverlust verursacht hat. Stattdessen setzen wir nur
// noch die current-user-id auf/um und lassen den Wrapper den Rest machen.

import { userStorage } from './userStorage';

/**
 * Nach erfolgreichem Login aufrufen. Setzt den aktuellen User im userStorage-Wrapper,
 * sodass künftige Zugriffe automatisch im richtigen User-Namespace landen.
 * Triggert außerdem einmalig die Migration alter unprefixed Keys auf den User-Namespace.
 */
export const handleLoginUserChange = (userId) => {
  if (!userId) return;
  userStorage.setCurrentUserId(String(userId));
};

/**
 * Beim Logout aufrufen. Löscht NICHT mehr die User-Daten (die bleiben für den
 * nächsten Login dieses Users verfügbar), sondern entkoppelt nur den Wrapper.
 * Damit ein zwischenzeitlich eingeloggter User nicht versehentlich
 * auf fremde Keys zugreift.
 */
export const handleLogoutCleanup = () => {
  userStorage.clearCurrentUserId();
};

/**
 * Legacy-Export für Backwards-Kompatibilität. Bewusst ein No-Op, damit älterer
 * Code nicht bricht, aber KEINE Daten mehr löscht.
 */
export const clearUserLocalData = () => {
  // No-op: siehe Kommentar oben. User-Isolation läuft jetzt über Namespace,
  // nicht über Datenlöschung.
};
